// common app & mfe

function Switch(props: {value: boolean, color: string}) {
    return (
        <div className="switch">
            <div className={`switch__rectangle ${props.value ? `${props.color}` : 'gray'}`}>
                <div className="switch__circle">

                </div>
            </div>
        </div>
    );
}

export default Switch